module.exports = __webpack_public_path__ + "static/media/device-complete-icon.f2a0ea4e.svg";